var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.categories)?_c('div',[_c('ul',_vm._l((_vm.categories),function(category){return _c('li',{key:category.id},[_vm._v(" "+_vm._s(category.name)+" ")])}),0)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }